<template>
  <div class="bright-block">
    <h2 class="bright-block__title">
      С&nbsp;TUC моменты<span
        ><img
          class="_icon"
          src="../assets/img/bright-taste/title-icon.svg"
          alt="" /></span
      ><br />
      становятся ярче
    </h2>
    <div class="bright-block__story">
      <div class="bright-block__story__line --left --line-1">
        <img class="_photo" src="../assets/img/bright-taste/photo-1.webp" />
        <img class="_kr" src="../assets/img/bright-taste/kr-1.webp" />
        <div class="_text">
          <div class="_row-1">Дома</div>
          <div class="_row-2">за любимым<br />сериалом</div>
          <img class="_connect" src="../assets/img/bright-taste/line-1.svg" />
        </div>
      </div>
      <div class="bright-block__story__line --right --line-2">
        <img class="_photo" src="../assets/img/bright-taste/photo-2.webp" />
        <div class="_text">
          <div class="_row-1">В УНИВЕРЕ</div>
          <div class="_row-2">на паре или<br />в перерыве</div>
          <img class="_connect" src="../assets/img/bright-taste/line-2.svg" />
        </div>
      </div>
      <div class="bright-block__story__line --left --line-3">
        <img class="_photo" src="../assets/img/bright-taste/photo-3.webp" />
        <img class="_kr" src="../assets/img/bright-taste/kr-2.webp" />
        <div class="_text">
          <div class="_row-1">На вечеринке</div>
          <div class="_row-2">с друзьями</div>
          <img class="_connect" src="../assets/img/bright-taste/line-3.svg" />
        </div>
      </div>
      <div class="bright-block__story__line --right --line-4">
        <img class="_photo" src="../assets/img/bright-taste/photo-4.webp" />
        <img class="_kr" src="../assets/img/bright-taste/kr-3.webp" />
        <div class="_text">
          <div class="_row-1">В путешествии</div>
          <div class="_row-2">и в поезде, и у костра</div>
          <img class="_connect" src="../assets/img/bright-taste/line-2.svg" />
        </div>
      </div>
      <div class="bright-block__story__line --left --line-5">
        <img class="_photo" src="../assets/img/bright-taste/photo-6.webp" />
        <img class="_kr" src="../assets/img/bright-taste/kr-1.webp" />
        <div class="_text">
          <div class="_row-1">в компании</div>
          <div class="_row-2">за просмотром<br>матча</div>
          <svg class="_connect" width="59" height="173" viewBox="0 0 59 173" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.33787 2.11211C57.7066 37.8203 81.4492 119.529 19.5614 171.009" stroke="#00188A" stroke-width="5" stroke-dasharray="8 8"/>
          </svg>
        </div>
      </div>
      <div class="bright-block__story__line --right --line-4">
        <img class="_photo" src="../assets/img/bright-taste/photo-5.webp" />
        <div class="_text">
          <div class="_row-1">С ДРУЗЬЯМИ</div>
          <div class="_row-2">за приставкой</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BrightBlock",
}
</script>

<style lang="scss">
.bright-block {
  background-color: $color-yellow;
  padding: 126px 0 70px;
  overflow: hidden;
  &__title {
    @include title();
    font-size: 11.2rem;
    position: relative;
    width: fit-content;
    margin: 0 auto;
    ._icon {
      position: absolute;
      left: 100%;
      top: -40px;
      transform: translateX(4px);
    }
  }
  &__story {
    color: $color-blue;
    max-width: 960px;
    margin: 80px auto 0;
    &__line {
      display: flex;
      ._photo {
        max-width: 420px;
      }
      ._text {
        position: relative;
        ._row-1 {
          font-family: $font-peach;
          font-size: 6.4rem;
        }
        ._row-2 {
          font-family: $font-text;
          font-size: 2.8rem;
          line-height: 0.95;
        }
      }
      ._connect {
        position: absolute;
      }
      &.--line-1 {
        position: relative;
        ._text {
          transform: rotate(-10deg) translateY(55px) translateX(40px);
        }
        ._connect {
          top: 148px;
          left: 82px;
          transform: rotate(12deg);
        }
        ._kr {
          max-width: 286px;
          position: absolute;
          top: -100px;
          right: 80px;
        }
      }
      &.--line-2 {
        flex-direction: row-reverse;
        margin-top: -130px;
        ._text {
          transform: rotate(2deg) translateY(125px) translateX(-20px);
        }
        ._photo {
          max-width: 460px;
        }
        ._connect {
          top: 85px;
          left: -95px;
        }
      }
      &.--line-3 {
        margin-top: -50px;
        position: relative;
        ._text {
          transform: rotate(-10deg) translateY(55px) translateX(20px);
        }
        ._kr {
          max-width: 215px;
          position: absolute;
          top: -45px;
          left: -40px;
        }
        ._connect {
          top: 135px;
          left: 135px;
          transform: rotate(10deg);
        }
      }
      &.--line-4 {
        flex-direction: row-reverse;
        margin-top: -115px;
        position: relative;
        ._text {
          transform: rotate(2deg) translateY(138px) translateX(-15px);
          ._row-2 {
            text-align: right;
            padding-right: 20px;
          }
        }
        ._photo {
          max-width: 460px;
        }
        ._kr {
          max-width: 170px;
          position: absolute;
          top: -95px;
          right: -25px;
        }
        ._connect {
          top: 124px;
          left: 22px;
        }
      }
      &.--line-5 {
        margin-top: 20px;
        position: relative;
        ._text {
          transform: rotate(-10deg) translateY(55px) translateX(20px);
        }
        ._kr {
          max-width: 286px;
          position: absolute;
          top: -62px;
          left: 627px;
        }
        ._connect {
          top: 108px;
          left: 214px;
          transform: rotate(-23deg);
        }
      }
    }
  }
}
@include respond-to("small") {
  .bright-block {
    &__title {
      font-size: 8.6rem;
    }
  }
}
@include respond-to("smartphone-plus") {
  .bright-block {
    box-shadow: 0px 30px 80px rgba(56, 0, 1, 0.5);
    border-radius: 48px 48px 0px 0px;
    margin-top: -48px;
    position: relative;
    z-index: 20;
    padding: 96px 0;

    &__title {
      font-size: 4.8rem;
      ._icon {
        top: -17px;
        transform: translateX(75px);
        width: 60px;
      }
    }
    &__story {
      padding: 0 20px;
      margin-top: 0;
      &__line {
        display: block;
        text-align: center;
        ._photo {
          max-width: 90% !important;
        }
        ._text {
          ._row-1 {
            font-size: 4.4rem;
          }
          ._row-2 {
            font-size: 2.4rem;
            br {
              //   display: none;
              content: "";
              position: relative;
              &:before {
                content: " ";
              }
            }
          }
        }
      }
      &__line.--line-1 {
        ._text {
          transform: rotate(0) translate(0, 0);
        }
        ._connect {
          transform: rotate(54deg) translate(25%, -45%);
          left: 37%;
        }
        ._kr {
          top: calc(100% + 30px);
          width: 154px;
          right: auto;
          left: calc(50% - 160px);
          z-index: 10;
        }
      }

      &__line.--line-2 {
        margin-top: 175px;
        ._text {
          transform: rotate(0) translate(0, 0);
          margin-top: -35px;
        }
        ._connect {
          top: 75px;
          left: calc(24% - 25px);
          height: 150px;
          transform: rotate(354deg);
        }
      }

      &__line.--line-3 {
        margin-top: 130px;
        ._text {
          transform: rotate(0) translate(0, 0);
          margin-top: -20px;
        }
        ._kr {
          max-width: 200px;
          left: -25px;
        }
        ._connect {
          transform: rotate(-140deg);
          top: 112px;
          left: 121px;
          width: 85px;
        }
      }

      &__line.--line-4 {
        margin-top: 115px;
        ._text {
          transform: rotate(0) translate(0, 0);
          margin-top: -35px;
        }
        ._kr {
          right: 0;
          top: -99px;
        }
        ._connect {
          top: 75px;
          left: calc(50% - 25px);
          height: 150px;
          transform: rotate(-198deg);
        }
      }

      &__line.--line-5 {
        margin-top: 130px;
        ._text {
          transform: rotate(0) translate(0, 0);
          margin-top: -20px;
        }
        ._kr {
          max-width: 200px;
          left: -25px;
        }
        ._connect {
          transform: rotate(180deg);
          top: 86px;
          left: 71px;
          width: 85px;
        }
      }
    }
  }
}

@media (min-width: 300px) and (max-width: 320px) {
  .bright-block__story__line.--line-1 ._kr {
    top: calc(94% + 30px);
    width: 154px;
    right: auto;
    left: calc(59% - 160px);
    z-index: 10;
  }

  .bright-block__story__line.--line-1 ._connect {
    transform: rotate(54deg) translate(8%, -30%);
    left: 37%;
  }

  .bright-block__story__line.--line-2 {
    margin-top: 139px;
  }

  .bright-block__story__line.--line-2 ._connect {
    top: 89px;
    left: calc(16% - 29px);
    height: 150px;
    transform: rotate(354deg);
  }

  .bright-block__story__line.--line-3 {
    margin-top: 105px;
  }

  .bright-block__story__line.--line-3 ._kr {
    max-width: 138px;
    left: 128px;
    top: -120px;
  }

  .bright-block__story__line.--line-3 ._connect {
    transform: rotate(41deg);
    top: 102px;
    left: 161px;
    width: 85px;
  }

  .bright-block__story__line.--line-4 {
    margin-top: 91px;
  }

  .bright-block__story__line.--line-4 ._kr {
    right: 113px;
    top: -115px;
  }

  .bright-block__story__line.--line-4 ._connect {
    top: 97px;
    left: calc(18% - 25px);
    height: 137px;
    transform: rotate(344deg);
  }

  .bright-block__story__line.--line-5 ._kr {
    max-width: 170px;
    left: 77px;
    top: -143px;
  }

  .bright-block__story__line.--line-5 ._connect {
    transform: rotate(22deg);
    top: 78px;
    left: 154px;
    width: 43px;
  }
}

@media (min-width: 321px) and (max-width: 920px) {
  .bright-block__story__line.--line-1 ._kr {
    top: calc(93% + 30px);
    width: 154px;
    right: auto;
    left: calc(54% - 160px);
    z-index: 10;
  }

  .bright-block__story__line.--line-2 {
    margin-top: 124px;
  }

  .bright-block__story__line.--line-2 ._connect {
    top: 75px;
    left: calc(18% - 25px);
    height: 150px;
    transform: rotate(354deg);
  }

  .bright-block__story__line.--line-3 {
    margin-top: 85px;
  }

  .bright-block__story__line.--line-3 ._kr {
    max-width: 172px;
    left: 74px;
    top: -98px;
  }

  .bright-block__story__line.--line-4 {
    margin-top: 94px;
  }

  .bright-block__story__line.--line-4 ._connect {
    top: 73px;
    left: calc(77% - 25px);
    height: 150px;
    transform: rotate(174deg);
  }

  .bright-block__story__line.--line-5 {
    margin-top: 111px;
  }

  .bright-block__story__line.--line-5 ._kr {
    max-width: 200px;
    left: -4px;
    top: -126px;
  }

  .bright-block__story__line.--line-5 ._connect {
    transform: rotate(190deg);
    top: 68px;
    left: 76px;
    width: 46px;
  }
}
</style>
